/**
 * Сервер авторизации живёт на отдельном домене (sso.api-ssmm.ru), не на шлюзе,
 * поэтому у него свой базовый адрес, а не общий API_BASE из utils/api.ts.
 */
const FALLBACK_OAUTH_BASE = 'https://sso.api-ssmm.ru';

export const OAUTH_BASE = (import.meta.env.VITE_OAUTH_BASE_URL || '').trim().replace(/\/+$/, '') || FALLBACK_OAUTH_BASE;

export type ConsentRequest = {
    client_name: string;
    // Хост адреса возврата — сервер отдаёт его отдельно от client_name, потому
    // что регистрация клиента открыта и не требует аутентификации: имя может
    // быть любым, а хост — единственное, что реально привязано к тому, куда
    // уйдёт код авторизации.
    client_redirect_host: string;
    resource: string;
    scope: string;
    expires_at: number;
};

const call = async <T>(path: string, token: string, init?: RequestInit): Promise<T> => {
    const response = await fetch(`${OAUTH_BASE}${path}`, {
        ...init,
        headers: { 'content-type': 'application/json', authorization: `Bearer ${token}`, ...(init?.headers ?? {}) },
    });

    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body?.error_description || body?.error || 'Не удалось выполнить запрос');

    return body as T;
};

export const fetchConsentRequest = (requestId: string, token: string): Promise<ConsentRequest> =>
    call<ConsentRequest>(`/oauth/authorize/request/${encodeURIComponent(requestId)}`, token);

export const approveConsent = (requestId: string, token: string): Promise<{ redirect_to: string }> =>
    call(`/oauth/authorize/approve`, token, { method: 'POST', body: JSON.stringify({ request_id: requestId }) });

export const denyConsent = (requestId: string, token: string): Promise<{ redirect_to: string }> =>
    call(`/oauth/authorize/deny`, token, { method: 'POST', body: JSON.stringify({ request_id: requestId }) });
